<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Generar Proyecciones</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <generate-projections-form v-show="!isDataLoaded" :subtitle="subtitle" @generate="generate" />
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import GenerateProjectionsForm from './GenerateProjectionsForm';
import swal from 'sweetalert2';

export default {
  components: {
    RouteBreadCrumb,
    GenerateProjectionsForm,
  },

  data() {
    return {
      distributor: null,
      campaign: null,
      subtitle: 'Elija las campañas y el distribuidor, y pulse en SELECCIONAR para generar las proyecciones',
    };
  },

  computed: {
    isDataLoaded() {
      return this.campaign && this.distributor;
    },
  },

  methods: {
    generate(params) {
      this.$services
        .resource('projection_generate')
        .create(params)
        .then(() => {
          swal({
            title: 'Listo!',
            text: 'Las proyecciones fueron generadas con éxito.',
            type: 'success',
            buttonsStyling: false,
            showCancelButton: false,
            confirmButtonText: 'Ir al listado',
            confirmButtonClass: 'btn btn-secondary',
          }).then((res) => {
            this.$router.push({ name: 'ProjectionsList' });
          });
        })
        .catch((error) => {
          swal({
            title: `Atención`,
            text: error.response.data,
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-warning',
            type: 'warning',
          });
        });
    },
  },
};
</script>
